/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Owningcompany1Inputs */

const en_entity_owningcompany1 = /** @type {(inputs: Entity_Owningcompany1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owning Company`)
};

const de_entity_owningcompany1 = /** @type {(inputs: Entity_Owningcompany1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besitzende Firma`)
};

/**
* | output |
* | --- |
* | "Owning Company" |
*
* @param {Entity_Owningcompany1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_owningcompany1 = /** @type {((inputs?: Entity_Owningcompany1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Owningcompany1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_owningcompany1(inputs)
	return de_entity_owningcompany1(inputs)
});
export { entity_owningcompany1 as "entity_owningCompany" }